module.exports = __webpack_public_path__ + "img/admin-noticias.e83c5614.svg";